/* tslint:disable */
/* eslint-disable */
export enum PlanFileCategory {
  Source = 'SOURCE',
  Result = 'RESULT',
  Main = 'MAIN'
}
